import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import { RouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";

import {
  Dashboard as DashboardView,
  ProductList as ProductListView,
  UserList as UserListView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  SalaryCalculator,
  BudgetView,
} from "./views";
import { TransactionView } from "views/Transactions";
import { Main as HomeView } from "./views/HomePage";
import { APIConsole } from "views/ApiConsole";
import { BehaviorPIP } from "views/BehaviorPIP";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomeView} />
      <Route exact path="/salary/calculator" component={SalaryCalculator} />
      <RouteWithLayout
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      />
      <RouteWithLayout
        component={UserListView}
        exact
        layout={MainLayout}
        path="/users"
      />
      <RouteWithLayout
        component={ProductListView}
        exact
        layout={MainLayout}
        path="/products"
      />
      <RouteWithLayout
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      />
      <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={TransactionView}
        exact
        layout={MainLayout}
        path="/transactions"
      />
      <RouteWithLayout
        component={BudgetView}
        exact
        layout={MainLayout}
        path="/budgets"
      />
      <RouteWithLayout
        component={APIConsole}
        exact
        layout={MainLayout}
        path="/console"
      />
      <RouteWithLayout
        component={BehaviorPIP}
        exact
        layout={MainLayout}
        path="/behavior-pip"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
